import {connect} from '@gisatcz/ptr-state';

import Select from '../../../state/Select';

import presentation from './presentation';

const mapStateToProps = (state, ownProps) => {
	return {
		feature: Select.specific.eo4sdDrrInsarVietnam20.getSelectedPointFeature(
			state
		), // TODO pass keys
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(presentation);
